import { put, call, takeEvery } from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACTION from "./actions";
import { toast } from "react-toastify";
import { GET_DRIVERS, VIEW_DRIVER } from "../../services/ApiCalls";

function* getDriversDataSaga({ payload, params, callBack }) {
  try {
    const response = yield call(GET_DRIVERS, payload, params);
    if (response.data.status == "success") {
      yield put(ACTION.getDriversSuccess(response?.data));
      callBack && callBack();
    } else {
      toast.error(response?.data?.message);
      yield put(ACTION.getDriversFail(error));
    }
  } catch (error) {
    yield put(ACTION.getDriversFail(error));
  }
}

function* getDriverViewDataSaga({ payload, callBack }) {
  try {
    const response = yield call(VIEW_DRIVER, payload);
    if (response.status == 200) {
      console.log(response);
      yield put(ACTION.getDriverViewSuccess(response?.data));
      callBack && callBack();
    } else {
      toast.error(response?.data?.message);
      yield put(ACTION.getDriverViewFail(error));
    }
  } catch (error) {
    yield put(ACTION.getDriverViewFail(error));
  }
}



function* driverSaga() {
  yield takeEvery(CONST.GET_DRIVERS, getDriversDataSaga);
  yield takeEvery(CONST.GET_DRIVER_VIEW, getDriverViewDataSaga);
}

export default driverSaga;
